import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ThemeWrapper from '../ThemeWrapper ';
import Loader from '../components/Loader';
import GuideSidebar from '../components/GuideSidebar';

const MyCalendar = () => {
    const [calendar, setCalendar] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCalendar = async () => {
            const hostData = getItemFromLocalStorage('hostProfile');
            let formData = new FormData();
            formData.append('token', hostData.host_access_token);

            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    url: `${params.baseURL}${params.endpoints.getMyCalendar}`,
                    data: formData,
                });

                if (response.data.items && Array.isArray(response.data.items)) {
                    setCalendar(response.data.items);
                    setLoading(false);
                } else {
                    setError('An error occurred while fetching data.');
                }
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };

        fetchCalendar();
    }, []);

    const openCalendarPage = (listing) => {
        navigate(`/calendar-view/${listing.stay_listing_id}`);
    };
    
    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <p>Error loading listings: {error.message}</p>;
    }

    return (
        <div>
            <Helmet>
                <title>Calendar</title>
                <meta name='description' content='' />
            </Helmet>

            <div className='row'>
                <div className='col-md-8'>
                    <div className='yl-header'>
                        <div className='img-title-box'>
                            <img src={'/assets/img/title/calendar_title_2.svg'} className='img-fluid img-title' alt='' />
                        </div>
                    </div>

                    {calendar.length > 0 ? (
                        <div className='row'>
                            {calendar.map((data) => (
                                <div className='col-md-12 lb mb-3' key={data.stay_listing_id}>
                                    <ThemeWrapper categoryId={data.category_id}>
                                        <a href='javascript:void(0);' className='mcldb' onClick={() => openCalendarPage(data)}>
                                            <div className='mcaldbox'>
                                                <div className='mcd-image'>
                                                    <img
                                                        src={data.cover_photo ? data.cover_photo : '/assets/img/default_listing.jpg'}
                                                        alt={data.listing_title ? data.listing_title : 'Untitled Listing'}
                                                    />
                                                </div>
                                                <div className='mcd-title'>
                                                    <img src={data.property_title_icon_image} alt='' className='img-fluid pointer-icon' style={{boxShadow:'none'}} />
                                                    <p>
                                                        {data.listing_title ? data.listing_title : ''}
                                                        <span style={{marginLeft:'5px',color:'darkgrey'}}>
                                                        {
                                                        (() => {
                                                            const address = data.property_address?.trim() || '';
                                                            const limit = 50;

                                                            return address.length > limit
                                                            ? address.slice(0, limit) + '...'
                                                            : address;
                                                        })()
                                                        }
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className='cal-img'>
                                                <img src={'assets/img/icons/calendar_manager_2.svg'} alt='' className='img-fluid' />
                                            </div>
                                        </a>
                                    </ThemeWrapper>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p>No active listings found</p>
                    )}
                </div>
                <div className='col-md-4 p-0'>
                    <GuideSidebar slug="my-calendar" />
                </div>
            </div>

        </div>
    );
};

export default MyCalendar;
